import { Navigate } from 'react-router'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { ROUTES } from '../../routes/routeConfig'

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = sessionStorage.getItem('accessToken')
  const userRole = useSelector(state => state.user.role)

  // If not logged in → go to login
  if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  // If allowedRoles specified, check if user's role is permitted
  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  // If logged in and authorized → allow access
  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
}

export default ProtectedRoute
